var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg23Transport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "s"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "v"
  })), /*#__PURE__*/React.createElement("g", {
    id: "w"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "x"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 58,
    r: 5,
    style: {
      fill: "#273640"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 58,
    r: 3,
    style: {
      fill: "#202d35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,60c-1.103,0-2-.897-2-2s.897-2,2-2,2,.897,2,2-.897,2-2,2Zm0-2.002v0Z",
    style: {
      fill: "#1d252d"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 58,
    r: 5,
    style: {
      fill: "#273640"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 58,
    r: 3,
    style: {
      fill: "#202d35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,60c-1.103,0-2-.897-2-2s.897-2,2-2,2,.897,2,2-.897,2-2,2Zm0-2.002v0Z",
    style: {
      fill: "#1d252d"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63,56c0,1.1-.9,2-2,2h-4c0-3.87-3.13-7-7-7s-7,3.13-7,7h-4v-23h9.65c.81,0,1.55,.5,1.85,1.26l3,7.48c.3,.76,1.04,1.26,1.85,1.26h1.65c2.21,0,4,1.79,4,4v5c1.1,0,2,.9,2,2Z",
    style: {
      fill: "#b50b38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,49v4c-9.94,0-18-8.06-18-18h5.65c.81,0,1.55,.5,1.85,1.26l3,7.48c.3,.76,1.04,1.26,1.85,1.26h1.65c2.21,0,4,1.79,4,4Z",
    style: {
      fill: "#f20f4b"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "50 45 42 45 42 38 47.3 38 50 45",
    style: {
      fill: "#c8c2b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,45h-3.96c-1.39-2.07-2.36-4.44-2.78-7h4.04l2.7,7Z",
    style: {
      fill: "#e7e5e0"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36,48v10h-9c0-3.87-3.13-7-7-7s-7,3.13-7,7h-5c-1.1,0-2-.9-2-2s.9-2,2-2v-6h28Z",
    style: {
      fill: "#b50b38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,48v9c-3.33,0-6.47-.33-9.27-.93-.83-2.93-3.53-5.07-6.73-5.07-1.12,0-2.18,.26-3.11,.73-1.21-1.13-1.89-2.4-1.89-3.73h21Z",
    style: {
      fill: "#f20f4b"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44,50h-1c-1.104,0-2-.896-2-2s.896-2,2-2h1c1.104,0,2,.896,2,2s-.896,2-2,2Z",
    style: {
      fill: "#97092f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,49h-1c-.553,0-1-.447-1-1s.447-1,1-1h1c.553,0,1,.447,1,1s-.447,1-1,1Z",
    style: {
      fill: "#273640"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36,46H8c-.553,0-1-.447-1-1s.447-1,1-1h28c.553,0,1,.447,1,1s-.447,1-1,1Z",
    style: {
      fill: "#273640"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,54h6.26c-.8,1.13-1.26,2.51-1.26,4h-5c-1.1,0-2-.9-2-2s.9-2,2-2Z",
    style: {
      fill: "#202d35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.74,54h10.26v4h-9c0-1.49-.46-2.87-1.26-4Z",
    style: {
      fill: "#273640"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.26,54c-.8,1.13-1.26,2.51-1.26,4h-4v-4h5.26Z",
    style: {
      fill: "#273640"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,56c0,1.1-.9,2-2,2h-4c0-1.49-.46-2.87-1.26-4h5.26c1.1,0,2,.9,2,2Z",
    style: {
      fill: "#273640"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23,1c12.15,0,22,8.954,22,20,0,6.524-3.437,12.316-8.754,15.967,.591,2.346,2.17,4.033,3.754,4.033-2.769,0-5.274-.762-7.085-2.148-2.98,1.371-6.347,2.148-9.915,2.148-12.15,0-22-8.954-22-20,0-11.046,9.85-20,22-20Z",
    style: {
      fill: "#415fb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,21c0,4.88-1.92,9.35-5.12,12.82-3.43,2.02-7.5,3.18-11.88,3.18-12.15,0-22-8.95-22-20,0-4.88,1.92-9.35,5.12-12.82,3.43-2.02,7.5-3.18,11.88-3.18,12.15,0,22,8.95,22,20Z",
    style: {
      fill: "#577ef2"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "10 14 10 28 23 34 23 20 10 14",
    style: {
      fill: "#735639"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "36 14 36 28 23 34 23 20 23.75 19.65 36 14",
    style: {
      fill: "#a67c52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,14v12c-5.06,0-9.53-2.51-12.25-6.35l12.25-5.65Z",
    style: {
      fill: "#c69c6d"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "36 14 31.83 15.92 27.67 17.85 23 20 10 14 14.67 11.85 18.83 9.92 23 8 36 14",
    style: {
      fill: "#8a6744"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,14l-4.17,1.92-4.16,1.93-3.92,1.8c-1.73-2.44-2.75-5.43-2.75-8.65,0-.73,.05-1.45,.15-2.15l1.85-.85,13,6Z",
    style: {
      fill: "#a67c52"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "31.83 15.92 27.67 17.85 14.67 11.85 18.83 9.92 31.83 15.92",
    style: {
      fill: "#f7b011"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.83,15.92l-4.16,1.93-6.12-2.82c-.36-1.28-.55-2.63-.55-4.03v-.08l10.83,5Z",
    style: {
      fill: "#fcee21"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26,29c-.553,0-1-.448-1-1v-1c0-.552,.447-1,1-1s1,.448,1,1v1c0,.552-.447,1-1,1Z",
    style: {
      fill: "#8a6744"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,28c-.553,0-1-.448-1-1v-1c0-.552,.447-1,1-1s1,.448,1,1v1c0,.552-.447,1-1,1Z",
    style: {
      fill: "#8a6744"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27,28c-.553,0-1-.448-1-1v-1c0-.552,.447-1,1-1s1,.448,1,1v1c0,.552-.447,1-1,1Z",
    style: {
      fill: "#273640"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,27c-.553,0-1-.448-1-1v-1c0-.552,.447-1,1-1s1,.448,1,1v1c0,.552-.447,1-1,1Z",
    style: {
      fill: "#273640"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "y"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61,59h-4c-.553,0-1-.447-1-1,0-3.309-2.691-6-6-6s-6,2.691-6,6c0,.553-.447,1-1,1h-4c-.553,0-1-.447-1-1v-23c0-.553,.447-1,1-1h9.65c1.216,0,2.333,.761,2.78,1.893l2.997,7.476c.15,.38,.52,.632,.922,.632h1.65c2.757,0,5,2.243,5,5v4.171c1.164,.413,2,1.525,2,2.829,0,1.654-1.346,3-3,3Zm-3.063-2h3.063c.552,0,1-.448,1-1s-.448-1-1-1-1-.447-1-1v-5c0-1.654-1.346-3-3-3h-1.65c-1.216,0-2.333-.761-2.78-1.893l-2.997-7.476c-.15-.38-.52-.632-.922-.632h-8.65v21h2.062c.493-3.94,3.865-7,7.938-7s7.444,3.06,7.937,7Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,46h-8c-.553,0-1-.447-1-1v-7c0-.553,.447-1,1-1h5c.4,0,.762,.238,.919,.606l3,7c.133,.309,.101,.663-.084,.944-.186,.28-.499,.449-.835,.449Zm-7-2h5.483l-2.143-5h-3.341v5Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,59h-9c-.553,0-1-.447-1-1,0-3.309-2.691-6-6-6s-6,2.691-6,6c0,.553-.447,1-1,1h-5c-1.654,0-3-1.346-3-3,0-1.304,.836-2.416,2-2.829v-5.171c0-.553,.447-1,1-1h28c.553,0,1,.447,1,1v10c0,.553-.447,1-1,1Zm-8.063-2h7.063v-8H9v5c0,.553-.447,1-1,1s-1,.448-1,1,.448,1,1,1h4.062c.493-3.94,3.865-7,7.938-7s7.444,3.06,7.937,7Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50,60c-1.103,0-2-.897-2-2s.897-2,2-2,2,.897,2,2-.897,2-2,2Zm0-2.002v0Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,64c-3.309,0-6-2.691-6-6s2.691-6,6-6,6,2.691,6,6-2.691,6-6,6Zm0-10c-2.206,0-4,1.794-4,4s1.794,4,4,4,4-1.794,4-4-1.794-4-4-4Z",
    style: {
      fill: "#222325"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20,60c-1.103,0-2-.897-2-2s.897-2,2-2,2,.897,2,2-.897,2-2,2Zm0-2.002v0Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,64c-3.309,0-6-2.691-6-6s2.691-6,6-6,6,2.691,6,6-2.691,6-6,6Zm0-10c-2.206,0-4,1.794-4,4s1.794,4,4,4,4-1.794,4-4-1.794-4-4-4Z",
    style: {
      fill: "#222325"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44,49h-1c-.553,0-1-.447-1-1s.447-1,1-1h1c.553,0,1,.447,1,1s-.447,1-1,1Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,46H8c-.553,0-1-.447-1-1s.447-1,1-1h28c.553,0,1,.447,1,1s-.447,1-1,1Z",
    style: {
      fill: "#222325"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23,35c-.143,0-.286-.03-.419-.092l-13-6c-.354-.164-.581-.519-.581-.908V14c0-.553,.447-1,1-1s1,.447,1,1v13.36l12,5.538,12-5.538V14c0-.553,.447-1,1-1s1,.447,1,1v14c0,.39-.227,.744-.581,.908l-13,6c-.133,.062-.276,.092-.419,.092Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,21c-.143,0-.286-.03-.419-.092l-13-6c-.354-.164-.581-.519-.581-.908s.227-.744,.581-.908l13-6c.266-.123,.572-.123,.838,0l13,6c.354,.164,.581,.519,.581,.908s-.227,.744-.581,.908l-13,6c-.133,.062-.276,.092-.419,.092Zm-10.613-7l10.613,4.898,10.613-4.898-10.613-4.898-10.613,4.898Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,35c-.553,0-1-.447-1-1v-14c0-.553,.447-1,1-1s1,.447,1,1v14c0,.553-.447,1-1,1Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 5.841,
    width: 2,
    height: 14.318,
    transform: "translate(3.011 30.705) rotate(-65.225)",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 7.841,
    width: 2,
    height: 14.318,
    transform: "translate(-1.129 28.235) rotate(-65.225)",
    style: {
      fill: "#222325"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27,28c-.553,0-1-.447-1-1v-1c0-.553,.447-1,1-1s1,.447,1,1v1c0,.553-.447,1-1,1Z",
    style: {
      fill: "#222325"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,27c-.553,0-1-.447-1-1v-1c0-.553,.447-1,1-1s1,.447,1,1v1c0,.553-.447,1-1,1Z",
    style: {
      fill: "#222325"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40,42c-2.739,0-5.27-.707-7.201-2.001-3.079,1.328-6.373,2.001-9.799,2.001C10.317,42,0,32.579,0,21S10.317,0,23,0s23,9.421,23,21c0,6.43-3.12,12.355-8.588,16.365,.602,1.662,1.73,2.635,2.588,2.635,.553,0,1,.447,1,1s-.447,1-1,1ZM23,2C11.421,2,2,10.523,2,21s9.421,19,21,19c3.334,0,6.529-.691,9.497-2.056,.337-.156,.73-.11,1.025,.114,.757,.579,1.656,1.038,2.655,1.364-.386-.647-.695-1.395-.901-2.212-.103-.405,.059-.832,.403-1.068,5.288-3.631,8.32-9.149,8.32-15.143,0-10.477-9.421-19-21-19Z",
    style: {
      fill: "#222325"
    }
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "a`"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "aa"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "ab"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "ac"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "ad"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "ae"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "af"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg23Transport);
export default __webpack_public_path__ + "static/media/23-transport.9897f0915aed4bf20b5b6c116e32a252.svg";
export { ForwardRef as ReactComponent };